export const customStyles = {
  option: (provided, state) => ({
    ...provided,
    color: state.isFocused ? "white" : "white",
    backgroundColor: state.isFocused && "#00968f",
    outerWidth: "100%"
  }),

  menuList: (provided, state) => ({
    ...provided,
    borderRadius: "0px 0px 12px 12px",
    margin: 0,
  }),

  menu: (provided, state) => ({
    ...provided,
    backgroundColor: "#00968f",
    borderRadius: "0px 0px 12px 12px",
    marginTop: 0,
    color: "#FFFFFF",
    outerWidth: "100%"
  }),

  input: (provided, state) => ({
    ...provided,
    backgroundColor: state.menuIsOpen && "#00968f",
    borderRadius: "12px",
    color: "#FFFFFF",
    marginTop: 0,
    outerWidth: "100%"
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: state.menuIsOpen && "#FFFFFF",
  }),
  noOptionsMessage: (provided, state) => ({
    ...provided,
    color: state.menuIsOpen && "#FFFFFF",
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: state.menuIsOpen && "#FFFFFF",
  }),
  clearIndicator: (provided, state) => ({
    ...provided,
    color: state.menuIsOpen && "#FFFFFF",
  }),
  container: (provided, state) => ({
    ...provided,
    borderRadius: "40px",
    marginTop: 0,
  }),

  singleValue: (provided, state) => ({
    ...provided,
    opacity: state.isDisabled ? 0.5 : 1,
    transition: "opacity 300ms",
  }),

  multiValue: (provided, state) => ({
    ...provided,
    backgroundColor: "#ECECEC",
    color: "#00968f",
    borderRadius: "40px",
    borderColor: "#00968f",
    padding: "1px",
    border: "1px",
  }),
  multiValueLabel: (provided, state) => ({
    ...provided,
    color: "#00968f",
  }),
  multiValueRemove: (provided, state) => ({
    ...provided,
    ":hover": {
      backgroundColor: "#ECECEC",
      borderRadius: "40px",
      color: "red",
    },
  }),
};
